module.exports = __webpack_public_path__ + "img/wallet_right.f5f0eef8.png";